import React from 'react';
import { Form, Select } from 'antd';

const MetricDisplayConfig = ({ namePath, metrics }) => (
  <>
    <Form.Item label="Display type" name={[...namePath, 'displayType']}>
      <Select
        options={[
          { label: 'Value', value: 'value' },
          { label: 'Hidden', value: 'hidden' },
          { label: 'Share of main segment', value: 'shareMainSegmentTotal' },
          { label: 'Share of segment', value: 'shareSegmentTotal' },
          { label: 'Difference from main segment', value: 'diffMainSegment' },
          { label: 'Rate', value: 'rate' },
        ]}
      />
    </Form.Item>
    <Form.Item label="Metrics" name={[...namePath, 'metrics']}>
      <Select
        mode="multiple"
        options={metrics}
      />
    </Form.Item>
    <Form.Item label="Format" name={[...namePath, 'format']}>
      <Select
        options={[
          { label: 'Number', value: 'number' },
          { label: 'Percentage', value: 'percent' },
          { label: 'True or false', value: 'bool' },
          { label: 'Date', value: 'date' },
          { label: 'Time', value: 'time' },
          { label: 'Date & time', value: 'datetime' },
          { label: 'Duration from seconds', value: 'seconds' },
          { label: 'Duration from milliseconds', value: 'milliseconds' },
          { label: 'Relative date', value: 'relativeDate' },
        ]}
      />
    </Form.Item>
  </>
);

export default MetricDisplayConfig;
